export default function cx() {
  let classArr = [];
  const args = Array.prototype.slice.call(arguments);
  args.forEach((arg) => {
    if (arg) classArr.push(arg);
  });
  return classArr.join(' ');
}
